import React from 'react';
import { Box, Button } from '@mui/material';
import ExpandMenuArrow from '../../../../assets/icons/expand-menu-arrow-icon';
import useStyles from './styles';

type toggleDrawer = { handleClick: any; active: any };

const ToggleArrowDrawer = ({ handleClick, active }: toggleDrawer) => {
  const classes = useStyles();
  const toggleSideNav = active ? classes.expanded : classes.closed;

  return (
    <Box id="side-nav-toggle-drawer" className={classes.toggleContainer} flexGrow={1}>
      <Button className={classes.toggleBox} onClick={handleClick}>
        <ExpandMenuArrow className={toggleSideNav} />
      </Button>
    </Box>
  );
};

export default ToggleArrowDrawer;
